/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missing_Dialogue_TextInputs */

const en_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Alignment Process has detected missing dialogue. Would you like to create a new event group with the missing dialogue Events?`)
};

const fr_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le processus d’alignement a détecté des dialogues manquants. Voulez-vous créer un nouveau groupe d’événements avec ces dialogues manquants ?`)
};

const de_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Ausrichtungsprozess hat fehlende Dialoge festgestellt. Möchten Sie eine neue Ereignisgruppe mit den Ereignissen für die fehlenden Dialoge erstellen?`)
};

const it_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il processo di allineamento ha rilevato un dialogo mancante. Vuoi creare un nuovo gruppo di eventi con gli eventi di dialogo mancanti?`)
};

const ru_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В процессе выравнивания обнаружен отсутствующий диалог. Хотите создать новую группу событий с событиями, содержащими отсутствующий диалог?`)
};

const es_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proceso de alineación ha detectado un diálogo faltante. ¿Desea crear un nuevo grupo de eventos con los eventos de diálogo faltantes?`)
};

const zh_cn2_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对齐过程检测到缺少对话。您是否要创建一个包含这些缺失对话事件的新事件组？`)
};

const ja_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アライメントプロセスで欠落したダイアログが検出されました。欠落したダイアログイベントを含む新しいイベントグループを作成しますか？`)
};

const hi_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अलाइनमेंट प्रक्रिया में कुछ संवाद छूट गए हैं। क्या आप छूटे हुए संवादों के साथ एक नया इवेंट समूह बनाना चाहेंगे?`)
};

const pt_pt2_missing_dialogue_text = /** @type {(inputs: Missing_Dialogue_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O processo de alinhamento detectou diálogos ausentes. Deseja criar um novo grupo de eventos com os diálogos ausentes?`)
};

/**
* | output |
* | --- |
* | "The Alignment Process has detected missing dialogue. Would you like to create a new event group with the missing dialogue Events?" |
*
* @param {Missing_Dialogue_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const missing_dialogue_text = /** @type {((inputs?: Missing_Dialogue_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Dialogue_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_missing_dialogue_text(inputs)
	if (locale === "de") return de_missing_dialogue_text(inputs)
	if (locale === "it") return it_missing_dialogue_text(inputs)
	if (locale === "ru") return ru_missing_dialogue_text(inputs)
	if (locale === "es") return es_missing_dialogue_text(inputs)
	if (locale === "zh-CN") return zh_cn2_missing_dialogue_text(inputs)
	if (locale === "ja") return ja_missing_dialogue_text(inputs)
	if (locale === "hi") return hi_missing_dialogue_text(inputs)
	if (locale === "pt-PT") return pt_pt2_missing_dialogue_text(inputs)
	return en_missing_dialogue_text(inputs)
});